import React from 'react'
import { Trans } from 'react-i18next'

// Types
import { IJournalEntry, JournalEntryType } from '../common/models/Journal'
import { ICompanyMember, ICompany } from '../common/models/Company'

export const getSystemMessages = (
  entry: IJournalEntry,
  company?: ICompany,
  messageOwner?: ICompanyMember
) => {
  const otherValues =
    entry.entryType === JournalEntryType.TITLE_CHANGE
      ? {
          title: entry.newTitle,
        }
      : entry.entryType === JournalEntryType.PARTICIPANT_ADD ||
        entry.entryType === JournalEntryType.PARTICIPANT_REMOVE ||
        entry.entryType === JournalEntryType.LOST_ACCESS
      ? {
          participant: company?.allMembers.find(
            (mem) => mem._id === entry.participantId
          )?.firstName,
        }
      : undefined
  return (
    <Trans
      i18nKey={entry.content}
      values={{
        name: messageOwner?.firstName,
        ...otherValues,
      }}
    />
  )
}
